export default __webpack_public_path__ + "static/media/152.b9a17f13.jpg";